import { MARKER } from "../lib/palettes.js";
import { clampParam } from "../lib/scenario.js";

function ParamInput({ field, value, onChange }) {
  return (
    <label className="chaos-param">
      <span>
        {field.label}
        <em>{value}{field.unit ? ` ${field.unit}` : ""}</em>
      </span>
      <input
        className="wxr"
        type="range"
        min={field.min}
        max={field.max}
        step={field.step}
        value={value}
        onChange={(e) => onChange(clampParam(field, e.target.value))}
      />
    </label>
  );
}

export default function ScenarioPanel({ catalog, scenarios, selectedId, placing, horizon, onPick, onSelect, onParam, onRemove }) {
  const specByType = Object.fromEntries(catalog.disasters.map((d) => [d.type, d]));
  return (
    <section className="chaos-section">
      <div className="chaos-section-head">
        <h3>Disasters</h3>
        <span className="muted">{placing ? "Click the map to place" : `${scenarios.length} placed`}</span>
      </div>
      <div className="chaos-palette">
        {catalog.disasters.map((d) => (
          <button
            key={d.type}
            type="button"
            className={`chaos-pick${placing === d.type ? " on" : ""}`}
            style={{ "--pin": (MARKER[d.type] || {}).color }}
            title={d.description}
            onClick={() => onPick(placing === d.type ? null : d.type)}
          >
            <span className="glyph">{(MARKER[d.type] || {}).glyph}</span>
            {d.label}
          </button>
        ))}
      </div>
      {scenarios.length === 0 && <p className="chaos-empty">Pick a disaster, then click anywhere on the map. Drag a marker to move it.</p>}
      <ul className="chaos-list">
        {scenarios.map((s) => {
          const spec = specByType[s.type];
          const open = s.id === selectedId;
          return (
            <li key={s.id} className={open ? "open" : ""}>
              <button type="button" className="chaos-item-head" onClick={() => onSelect(open ? null : s.id)}>
                <span className="glyph" style={{ color: (MARKER[s.type] || {}).color }}>{(MARKER[s.type] || {}).glyph}</span>
                <span className="chaos-item-title">
                  {spec?.label || s.type}
                  <small>{s.lat.toFixed(2)}, {s.lon.toFixed(2)} · +{s.params.start_hour ?? 0} h</small>
                </span>
                <span className="chaos-x" role="button" tabIndex={0} aria-label="Remove" onClick={(e) => { e.stopPropagation(); onRemove(s.id); }} onKeyDown={(e) => e.key === "Enter" && onRemove(s.id)}>×</span>
              </button>
              {open && spec && (
                <div className="chaos-item-body">
                  {spec.params.map((f) => (
                    <ParamInput
                      key={f.key}
                      field={f.key === "start_hour" ? { ...f, max: horizon } : f}
                      value={s.params[f.key]}
                      onChange={(v) => onParam(s.id, f.key, v)}
                    />
                  ))}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
